import { Injectable } from '@angular/core';
import { get, set, del, clear } from 'idb-keyval';

@Injectable({
    providedIn: 'root'
})
export class StorageService {
  async save(key: string, value: any): Promise<void> {
    await set(key, value);
  }

  async read(key: string): Promise<any> {
    return await get(key);
  }

  async remove(key: string): Promise<void> {
    await del(key);
  }

  async clearAll(): Promise<void> {
    await clear();
  }

}
